/**
 * rowLabel — the ONE display name for a crop_cycle row, shared by the
 * sidebar, the chart, the verdict sentence and the table so a farmer
 * reads the same words everywhere. Farmers identify plantings by
 * Kultur + Schlag; the variety only disambiguates when no field name
 * is known.
 */
import type { DeckungsbeitragRow } from './types';

export function makeRowLabeler(
  fieldNames: Record<string, string>,
): (row: DeckungsbeitragRow) => string {
  return (row) => {
    const crop = row.crop || 'Unbenannte Kultur';
    const fieldName = row.field_id ? fieldNames[row.field_id] : undefined;
    if (fieldName) return `${crop} – ${fieldName}`;
    if (row.variety) return `${crop} · ${row.variety}`;
    return crop;
  };
}

/**
 * Kultur+Sorte group label (#2302) — "Erdbeeren · Sonata" — shared by the
 * chart's Kultur bars, the tree table's Level-1 sort and any caption that
 * names a group. ``crop`` is the display name (rollup already mapped blank
 * crops to "Unbenannte Kultur").
 */
export function kulturGroupLabel(group: { crop: string; variety: string | null }): string {
  return group.variety ? `${group.crop} · ${group.variety}` : group.crop;
}

/* #2948 §6 removed ``makeChartLabeler`` (the Schlag-name-only axis variant): its
   only consumer was the retired per-Schlag chart mode. Kultur bars label
   themselves through ``kulturGroupLabel`` above. */
